/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_AdminExerciseDto } from '../models/PagedResultDto_AdminExerciseDto';
import type { Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto } from '../models/Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_CreateReadyToTransferDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_CreateReadyToTransferDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_FillFundedAmountForCashExcerciseDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_FillFundedAmountForCashExcerciseDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseTransactionViewDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseTransactionViewDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_StatusDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_StatusDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_UpdateFMVOptionExerciseDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_UpdateFMVOptionExerciseDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Transaction_Transaction } from '../models/Wealthlane_AwardService_Transaction_Transaction';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OptionExerciseService {

    /**
     * @param settlementTypeIds 
     * @param grantIds 
     * @param recordTypes 
     * @param fromDate 
     * @param toDate 
     * @param showExercisedListOnly 
     * @param cancelledStatus 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_AdminExerciseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionExerciseOptionExercisedList(
settlementTypeIds?: Array<string>,
grantIds?: Array<string>,
recordTypes?: Array<string>,
fromDate?: string,
toDate?: string,
showExercisedListOnly?: boolean,
cancelledStatus?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_AdminExerciseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-exercise/option-exercised-list',
            query: {
                'SettlementTypeIds': settlementTypeIds,
                'GrantIds': grantIds,
                'RecordTypes': recordTypes,
                'FromDate': fromDate,
                'ToDate': toDate,
                'ShowExercisedListOnly': showExercisedListOnly,
                'CancelledStatus': cancelledStatus,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppOptionExerciseApplicableTaxes(
requestBody?: Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/option-exercise/applicable-taxes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param exerciseId 
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseTransactionViewDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionExerciseTransactionDetailByExerciseId(
exerciseId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseTransactionViewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-exercise/transaction-detail-by-exercise-id/{ExerciseId}',
            path: {
                'ExerciseId': exerciseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionExerciseReadyToTransfer(
requestBody?: Wealthlane_AwardService_Dtos_OptionExercise_CreateReadyToTransferDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-exercise/ready-to-transfer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionExerciseFillFundedAmountForCashExcercise(
requestBody?: Wealthlane_AwardService_Dtos_OptionExercise_FillFundedAmountForCashExcerciseDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-exercise/fill-funded-amount-for-cash-excercise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionExerciseCalculateOptionExerciseTax(
requestBody?: Array<string>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-exercise/calculate-option-exercise-tax',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fmv 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppOptionExerciseFMVByTransactionId(
fmv: number,
requestBody?: Wealthlane_AwardService_Dtos_OptionExercise_UpdateFMVOptionExerciseDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/option-exercise/f-mVBy-transaction-id',
            query: {
                'FMV': fmv,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_StatusDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionExerciseExerciseStatus(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionExercise_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-exercise/exercise-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param exerciseId 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionExerciseCalculateOptionExerciseTaxForSingleRecord(
exerciseId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-exercise/calculate-option-exercise-tax-for-single-record/{ExerciseId}',
            path: {
                'ExerciseId': exerciseId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionExerciseRaiseTransactionAddedEvent(
requestBody?: Wealthlane_AwardService_Transaction_Transaction,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-exercise/raise-transaction-added-event',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardNumber 
     * @returns boolean OK
     * @throws ApiError
     */
    public static putApiAwardApiAppOptionExerciseVestingDate(
awardNumber?: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/option-exercise/vesting-date',
            query: {
                'awardNumber': awardNumber,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param participantId 
     * @returns Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionExerciseIsoQualifiedList(
participantId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionAward_GetIsoQualifiedListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-exercise/iso-qualified-list/{participantId}',
            path: {
                'participantId': participantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
